import { render, staticRenderFns } from "./icon-pbx.vue?vue&type=template&id=e8869606&scoped=true&"
import script from "./icon-pbx.vue?vue&type=script&lang=js&"
export * from "./icon-pbx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8869606",
  null
  
)

export default component.exports